import { autoinject, PLATFORM } from 'aurelia-framework';
import './pen-view.scss';
import { I18N } from 'aurelia-i18n';
import { Tab } from 'elements/tabs/MnTabs';
import { AsyncErrorHandler, DialogHandler } from 'lib/ui';
import { PenDto } from 'models/pen/Pen';
import { PenService } from 'services/pen/pen-service';
import { DialogService } from 'aurelia-dialog';
import { WeldingMachineCreate } from './welding-machine-create';
import { PenSegmentWeldingLogCreateDialog } from './production/pen-segment-welding-log-create-dialog';
import { connectTo } from 'aurelia-store';
import { ApplicationState } from 'lib/state';
import { saveAs } from 'file-saver';

@autoinject
@connectTo()
export class PenView {
  protected penId: number;
  protected pen: PenDto;
  protected tabsReady = false;
  protected tabs: Tab[] = [
    {
      name: 'dimension',
      title: 'Dimensjoner',
      view: PLATFORM.moduleName('views/pens/pens-offers/dimension/tab'),
      data: {},
    },
    {
      name: 'specifications',
      title: this.t.tr('general.specifications'),
      view: PLATFORM.moduleName('views/pens/pen/specification/tab'),
      data: {},
    },
    {
      name: 'production',
      title: this.t.tr('general.production'),
      view: PLATFORM.moduleName('views/pens/pen/production/tab'),
      data: {},
    },
  ];

  protected state: ApplicationState;
  protected canGenerateCertificate: boolean = false;
  protected generateCertficateProgress: boolean = false;

  constructor(
    private t: I18N,
    private penService: PenService,
    private dialogService: DialogService,
    private dialog: DialogHandler
  ) {}

  async attached() {
    await this.getPen();

    //Temp by Email, for testing and development
    this.canGenerateCertificate =
      this.state.user.Email === 'stephan.balling@morenot.com' ||
      this.state.user.Email === 'lill.jacobsen@aquaknowledge.no' ||
      this.state.user.Email === 'ulrik.eikas@twoday.com'
        ? true
        : false;
  }

  activate(params: { id: number }) {
    this.penId = params.id;
  }

  @AsyncErrorHandler
  async getPen() {
    this.tabsReady = false;
    const { data } = await this.penService.getPen(this.penId);

    this.pen = data;

    for (const tab of this.tabs) {
      if (!tab.data) tab.data = {};
      tab.data = {
        penId: this.penId,
        penIdentifier: this.pen.PenIdentifier,
      };
    }

    this.tabsReady = true;
  }

  @AsyncErrorHandler
  async generateCertificate() {
    if (this.generateCertficateProgress) {
      return;
    }
    this.generateCertficateProgress = true;
    await this.penService.createCertificate(this.penId);
    const blob = await this.penService.getCertificate(this.penId);
    saveAs(blob.blob, blob.fileName);
    this.generateCertficateProgress = false;
  }

  protected async openGenerateWeldingLogDialog() {
    await this.dialog.open(PenSegmentWeldingLogCreateDialog, {
      pen: this.pen,
    });
  }

  protected createWeldingMachine() {
    void this.dialogService
      .open({
        viewModel: WeldingMachineCreate,
      })
      .whenClosed(() => {
        document.querySelector('html').style.overflowY = null;
      });
  }
}
